<template>
  <v-dialog
    v-model="active"
    persistent
    width="80%"
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6">
          Emisión de informe de antecedentes
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row justify="center">
            <v-col cols="12">
              <evaluado-info-card-component :expediente="expediente" />
            </v-col>
            <v-col cols="12">
              <v-divider />
            </v-col>
          </v-row>
          <v-form
            ref="form"
            v-model="antecedentesForm"
          >
            <v-row>
              <v-col>
                <v-menu
                  v-model="menuFechaEmision"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      :value="computedFechaEmision"
                      label="Fecha de emisión"
                      prepend-icon="mdi-calendar"
                      readonly
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      v-bind="attrs"
                      :rules="required"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="antecedentes.fechaEmision"
                    @input="menuFechaEmision = false"
                  />
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  v-model="menuFechaOficio"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      :value="computedFechaOficio"
                      label="Fecha del oficio"
                      prepend-icon="mdi-calendar"
                      readonly
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="antecedentes.fechaOficio"
                    @input="menuFechaOficio = false"
                  />
                </v-menu>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="antecedentes.oficioAntecedentes"
                  label="Número de oficio de informe de antecedentes"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                />
              </v-col>
              <v-col>
                <v-file-input
                  v-model="antecedentes.file"
                  label="Adjunto oficio de informe de antecedentes"
                  rounded
                  filled
                  background-color="primary"
                  color="secondary"
                  dense
                  :rules="required"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="antecedentes.resultado"
                  label="Resultado de informe de antecedentes (Opcional)"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="antecedentes.observaciones"
                  label="Observaciones"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  no-resize
                  rows="8"
                  :rules="required"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="antecedentes.fk_idCatSemaforoResultado"
                  label="Semáforo de resultado"
                  background-color="primary"
                  color="secondary"
                  rounded
                  filled
                  dense
                  :items="semaforoResultado"
                  item-value="id"
                  item-text="nombre"
                  item-color="secondary"
                  :rules="required"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="secondary"
          :loading="loading"
          :disabled="!antecedentesForm || loading"
          @click="triggerSaveAntecedentes"
        >
          Guardar informe
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import EvaluadoInfoCardComponent from '../EvaluadoInfoCardComponent.vue';

export default {
  components: {
    EvaluadoInfoCardComponent,
  },

  props: {
    active: {
      type: Boolean,
    },

    expediente: {
      type: Object,
      default: () => null,
    },

    idDerivacion: {
      type: Number,
      default: 0,
    },
    idProgramacion: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      loading: false,
      antecedentesForm: false,

      menuFechaEmision: false,
      menuFechaOficio: false,

      antecedentes: {
        fk_idExpediente: null,
        fechaElaboracion: moment().format('DD/MM/YYYY'),
        fechaEvaluacion: '',
        oficioAntecedentes: '',
        fechaOficio: '',
        matriculaCartilla: '',
        resultado: '',
        observaciones: '',
        adjunto: '',
        fechaEmision: '',
        file: null,
        fk_idCatSemaforoResultado: null,
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    computedFechaEmision() {
      return this.antecedentes.fechaEmision ? moment(this.antecedentes.fechaEmision).format('DD/MM/YYYY') : '';
    },

    computedFechaOficio() {
      return this.antecedentes.fechaOficio ? moment(this.antecedentes.fechaOficio).format('DD/MM/YYYY') : '';
    },

    ...mapGetters('semaforoResultado', {
      semaforoResultado: 'getSemaforoResultado',
    }),
  },

  methods: {
    ...mapActions('evaluacionesAntecedentes', ['saveEvaluacionAntecedentes']),
    ...mapActions('derivaciones', ['updateDerivacion', 'updateEstatusDerivacion', 'fetchDerivacionesByArea']),

    closeDialog() {
      this.loading = false;
      this.antecedentes = {
        fk_idExpediente: null,
        fechaElaboracion: moment().format('DD/MM/YYYY'),
        fechaEvaluacion: '',
        oficioAntecedentes: '',
        fechaOficio: '',
        matriculaCartilla: '',
        resultado: '',
        observaciones: '',
        adjunto: '',
        fechaEmision: '',
        file: null,
        fk_idCatSemaforoResultado: null,
      };
      this.$refs.form.resetValidation();
      this.$emit('close');
    },

    async triggerSaveAntecedentes() {
      this.loading = true;
      await this.saveEvaluacionAntecedentes({
        fk_idDerivacion: this.idDerivacion,
        fk_idExpediente: this.expediente.idExpediente,
        fechaElaboracion: moment().format('DD/MM/YYYY'),
        fechaEvaluacion: moment().format('DD/MM/YYYY'),
        oficioAntecedentes: this.antecedentes.oficioAntecedentes,
        fechaOficio: this.computedFechaOficio,
        matriculaCartilla: '',
        resultado: this.antecedentes.resultado,
        observaciones: this.antecedentes.observaciones,
        adjunto: this.antecedentes.file.name,
        fechaEmision: this.computedFechaEmision,
        file: this.antecedentes.file,
        fk_idCatSemaforoResultado: this.antecedentes.fk_idCatSemaforoResultado,
      });

      await this.updateEstatusDerivacion({
        fk_idProgramacion: this.idProgramacion,
        idDerivacion: this.idDerivacion,
      });
      await this.fetchDerivacionesByArea(21);

      this.closeDialog();
    },
  },
};
</script>
